import Styles from '../../../1.manual/3.school/2.edit/styles.module.css';
import React from 'react';
import { useState } from 'react';
import { getFirestore } from 'firebase/firestore';
import { writeJobPostingBothStores } from '../../jobPostingRef';
import DefaultSelect1 from '../../../../package/1-select/index';
import ErrorMessage from '../../../../package/error/index';
import { defaultEmployment17, employmentData17, employmentData18, employmentData20, infoData } from '../../../../../type';
import { defaultEmploymentWarning } from './5.20-employment';
import Employment from './5.20-employment';

type EmploymentProps = {
  companyId: string;
  year: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  info: infoData;
  employment20: employmentData20;
  setEmployment20: React.Dispatch<React.SetStateAction<employmentData20>>;
  employment18: employmentData18;
  setEmployment18: React.Dispatch<React.SetStateAction<employmentData18>>;
  employment17: employmentData17;
  setEmployment17: React.Dispatch<React.SetStateAction<employmentData17>>;
};

const SchoolEmployment18: React.FC<EmploymentProps> = ({ companyId, year, setChangeData, info, employment20, setEmployment20, employment18, setEmployment18, employment17, setEmployment17, }) => {

  const [ errorMessage, setErrorMessage ] = useState('');
  const [ banner, setBanner ] = useState<boolean>(false);
  const [ hintText, setHintText ] = useState<any>({ title: "", desc: "" });

  function validateCompanyData(data: employmentData17): string | null {
    if (!data.contents) return '求人内容を選択してください。';
    return null;
  }

  function check() {
    setErrorMessage('');
    window.scrollTo(0, 0);

    if (employment17.contents === "専門(20歳卒)の内容と異なる" || employment17.contents === "" || employment17.contents === "未選択") {
      const error = validateCompanyData(employment17);
      if (error) return setErrorMessage(error);
    }
    save(true);
  }

  const db = getFirestore();

  const [ uploading, setUploading ] = useState(false);

  const save = async (isCompleted: boolean) => {
    try {
      setUploading(true);

      const payload = {
        ...employment17,
        isCompleted,
        time: new Date(),
      };

      await writeJobPostingBothStores(db, companyId, year, {
        employment17: payload,
      });

      setChangeData(false);

    } catch (error) {
      console.error("保存エラー:", error);
      setUploading(true);
    } finally {
      setUploading(true);
      setBanner(true);
      setTimeout(() => setBanner(false), 1500);
    }
  };

  async function handleSame20() {
    await writeJobPostingBothStores(db, companyId, year, {
      employment17: employment20,
      'employment17.isCompleted': false,
      'employment17.contents': "専門(20歳卒)の内容と同一",
      'warning.employment17': defaultEmploymentWarning,
    })
  }

  async function handleDifferent() {
    await writeJobPostingBothStores(db, companyId, year, {
      employment17: defaultEmployment17,
      'employment17.isCompleted': false,
      'employment17.contents': "専門(20歳卒)の内容と異なる",
    })
  }

  return (
    <>
    {errorMessage && <ErrorMessage message={errorMessage} />}
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    {!employment17.contents || employment17.contents === "専門(20歳卒)の内容と同一" ?
    <>
      <div className={Styles.title_edit}>
        <h4>雇用条件</h4>
        <div className={Styles.title_edit_btn}>
          <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
          <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
        </div>
      </div>

      <div className={Styles.test_box}>

        <DefaultSelect1
          error={false}
          title={'求人内容'}
          list={['未選択', '専門(20歳卒)の内容と同一', '専門(20歳卒)の内容と異なる']}
          value={employment17.contents}
          setValue={(val: string) => {
            setEmployment17((prev) => ({ ...prev, contents: val }));
            setChangeData(true);

            if (val === '専門(20歳卒)の内容と同一') {
              handleSame20();
            } else if (val === '専門(20歳卒)の内容と異なる') {
              handleDifferent();
            }
          }}
          desc={''} hint={{title: "", desc: ""}} setHintText={setHintText} />

      </div>

    </> :
    <Employment
      graduateAge={17}
      companyId={companyId} year={year} setChangeData={setChangeData}
      info={info}
      employment20={employment20} setEmployment20={setEmployment20}
      employment18={employment18} setEmployment18={setEmployment18}
      employment17={employment17} setEmployment17={setEmployment17} />
    }

    </>
  );
}

export default SchoolEmployment18;
